import {doRequest} from '../../../helpers/network';
import {REQUEST_TYPE} from '../../../constants';
import {Karma} from '../../../helpers/Urls';

export const FETCH_DAVT_TASKS = 'FETCH_DAVT_TASKS';
export const FETCH_DAVT_TASKS_COMPLETED = 'FETCH_DAVT_TASKS_COMPLETED';
export const FETCH_DAVT_TASKS_FAILED = 'FETCH_DAVT_TASKS_FAILED';

export const SET_DATE_RANGE = 'SET_DATE_RANGE';

export const FETCH_TASK_DETAILS = 'FETCH_TASK_DETAILS';
export const FETCH_TASK_DETAILS_COMPLETED = 'FETCH_TASK_DETAILS_COMPLETED';
export const FETCH_TASK_DETAILS_FAILED = 'FETCH_TASK_DETAILS_FAILED';

export const SEND_TASK_FOR_APPROVAL = 'SEND_TASK_FOR_APPROVAL';
export const SEND_TASK_FOR_APPROVAL_COMPLETED =
  'SEND_TASK_FOR_APPROVAL_COMPLETED';
export const SEND_TASK_FOR_APPROVAL_FAILED = 'SEND_TASK_FOR_APPROVAL_FAILED';

export const SUBMIT_FS_QUESTIONNAIRE = 'SUBMIT_FS_QUESTIONNAIRE';
export const SUBMIT_FS_QUESTIONNAIRE_COMPLETED =
  'SUBMIT_FS_QUESTIONNAIRE_COMPLETED';
export const SUBMIT_FS_QUESTIONNAIRE_FAILED = 'SUBMIT_FS_QUESTIONNAIRE_FAILED';

export const TOGGLE_DAVT_USER_STATUS = 'TOGGLE_DAVT_USER_STATUS';
export const TOGGLE_DAVT_USER_STATUS_COMPLETED =
  'TOGGLE_DAVT_USER_STATUS_COMPLETED';
export const TOGGLE_DAVT_USER_STATUS_FAILED = 'TOGGLE_DAVT_USER_STATUS_FAILED';

export const RESET_PAGE = 'RESET_PAGE';

export const FETCH_OCR_DASHBOARD_DATA = 'FETCH_OCR_DASHBOARD_DATA';
export const FETCH_OCR_DASHBOARD_DATA_COMPLETED =
  'FETCH_OCR_DASHBOARD_DATA_COMPLETED';
export const FETCH_OCR_DASHBOARD_DATA_FAILED =
  'FETCH_OCR_DASHBOARD_DATA_FAILED';

export const SAVE_OCR_DASHBOARD_DATA = 'SAVE_OCR_DASHBOARD_DATA';
export const SAVE_OCR_DASHBOARD_DATA_COMPLETED =
  'SAVE_OCR_DASHBOARD_DATA_COMPLETED';
export const SAVE_OCR_DASHBOARD_DATA_FAILED = 'SAVE_OCR_DASHBOARD_DATA_FAILED';

export const RE_RUN_GEMINI_PROMPT = 'RE_RUN_GEMINI_PROMPT';
export const RE_RUN_GEMINI_PROMPT_COMPLETED = 'RE_RUN_GEMINI_PROMPT_COMPLETED';
export const RE_RUN_GEMINI_PROMPT_FAILED = 'RE_RUN_GEMINI_PROMPT_FAILED';

export const OCR_DASHBOARD_FILTER = 'OCR_DASHBOARD_FILTER';

export const ASSIGN_DAVT_TASK = 'ASSIGN_DAVT_TASK';
export const ASSIGN_DAVT_TASK_COMPLETED = 'ASSIGN_DAVT_TASK_COMPLETED';
export const ASSIGN_DAVT_TASK_FAILED = 'ASSIGN_DAVT_TASK_FAILED';

const INITIAL_STATE = {
  isFetchingTasks: false,
  isAssigningTask: false,
  isRequestingTaskDetails: false,
  sendingTaskForApproval: false,
  submittingQuestionnaire: false,
  hasError: false,
  error: '',
  selectedDateRange: null,
  selectedDateStrings: null,
  isOcrDataFetching: false,
  ocrDashboardData: {},
  isOCRDashboardDataSaved: false,
  reRunPromptFetched: false,
};

export const fetchDavtTasks = (
  page,
  search,
  resetPage = true,
  taskName = '',
  dateRange = '',
) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_DAVT_TASKS});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Karma.fetchDavtTasksURL(page, search, taskName, dateRange),
      });
      const {data, status} = response || {};
      if (resetPage) {
        dispatch({type: RESET_PAGE});
      }

      if (status === true) {
        dispatch({
          type: FETCH_DAVT_TASKS_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: FETCH_DAVT_TASKS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_DAVT_TASKS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const setDateRange = (dates, dateStrings) => ({
  type: SET_DATE_RANGE,
  payload: {
    dates,
    dateStrings,
  },
});

export const fetchTaskDetails = (taskId) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_TASK_DETAILS});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Karma.fetchTaskDetailsURL(taskId),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: FETCH_TASK_DETAILS_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: FETCH_TASK_DETAILS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_TASK_DETAILS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const sendTaskForApproval = (actionType, requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: SEND_TASK_FOR_APPROVAL});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Karma.sendTaskForApprovalURL(actionType),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: SEND_TASK_FOR_APPROVAL_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: SEND_TASK_FOR_APPROVAL_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: SEND_TASK_FOR_APPROVAL_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const submitFSQuestionnaire = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: SUBMIT_FS_QUESTIONNAIRE});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Karma.submitFSQuestionnaireURL(),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: SUBMIT_FS_QUESTIONNAIRE_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: SUBMIT_FS_QUESTIONNAIRE_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: SUBMIT_FS_QUESTIONNAIRE_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const toggleDavtUserStatus = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: TOGGLE_DAVT_USER_STATUS});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Karma.toggleDavtUserStatusURL(),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: TOGGLE_DAVT_USER_STATUS_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: TOGGLE_DAVT_USER_STATUS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: TOGGLE_DAVT_USER_STATUS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const fetchOCRDashboardData = (
  caseType = false,
  page = '1',
  query = '',
  extraParams = {},
) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({
        type: FETCH_OCR_DASHBOARD_DATA,
        meta: {extraParams},
      });
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Karma.fetchOCRDashboardDataURL(caseType, page, query, extraParams),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: FETCH_OCR_DASHBOARD_DATA_COMPLETED,
          payload: {...data},
          meta: {extraParams},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: FETCH_OCR_DASHBOARD_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_OCR_DASHBOARD_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const saveOCRDashboardData = (
  requestData,
  caseType = false,
  page = 1,
  query = '',
) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: SAVE_OCR_DASHBOARD_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Karma.saveOCRDashboardDataURL(caseType, page, query),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: SAVE_OCR_DASHBOARD_DATA_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: SAVE_OCR_DASHBOARD_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: SAVE_OCR_DASHBOARD_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const assignDavtTask = (requestData) => {
  return async (dispatch) => {
    let response = {};

    try {
      dispatch({type: ASSIGN_DAVT_TASK});

      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Karma.assignDavtTaskURL(),
        data: requestData,
      });

      const {data, status} = response || {};

      if (status) {
        dispatch({
          type: ASSIGN_DAVT_TASK_COMPLETED,
          payload: {...data, requestData},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: ASSIGN_DAVT_TASK_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: ASSIGN_DAVT_TASK_FAILED,
        payload: {error: err.message},
      });
    }

    return response;
  };
};

export const reRunPrompt = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: RE_RUN_GEMINI_PROMPT});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Karma.reRunPromptURL(),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: RE_RUN_GEMINI_PROMPT_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: RE_RUN_GEMINI_PROMPT_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: RE_RUN_GEMINI_PROMPT_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const applyOCRDashboardFilter = (filter = {}) => {
  return (dispatch) => {
    dispatch({
      type: OCR_DASHBOARD_FILTER,
      payload: filter,
    });
  };
};

export default (state = INITIAL_STATE, action) => {
  const {type, payload, meta = {}} = action || {};
  const {extraParams = {}} = meta;
  switch (type) {
    case FETCH_DAVT_TASKS:
      return {
        ...state,
        isFetchingTasks: true,
      };
    case FETCH_DAVT_TASKS_COMPLETED:
      return {
        ...state,
        isFetchingTasks: false,
        tasksData: payload,
        hasError: false,
      };
    case FETCH_DAVT_TASKS_FAILED:
      return {
        ...state,
        isFetchingTasks: false,
        tasksData: {
          //CLEARING OLD DATA ON FAILURE
          tasks: {},
          task_ids: [],
          total: 0,
        },
        hasError: true,
        error: payload.error,
      };
    case FETCH_TASK_DETAILS:
      return {
        ...state,
        isRequestingTaskDetails: true,
      };
    case FETCH_TASK_DETAILS_COMPLETED:
      return {
        ...state,
        hasError: false,
        isRequestingTaskDetails: false,
        taskDetailsData: payload,
      };
    case FETCH_TASK_DETAILS_FAILED:
      return {
        ...state,
        hasError: true,
        isRequestingTaskDetails: false,
      };
    case SEND_TASK_FOR_APPROVAL:
      return {
        ...state,
        sendingTaskForApproval: true,
      };
    case SEND_TASK_FOR_APPROVAL_COMPLETED:
      return {
        ...state,
        sendingTaskForApproval: false,
        tasksData: payload,
        hasError: false,
      };
    case SEND_TASK_FOR_APPROVAL_FAILED:
      return {
        ...state,
        sendingTaskForApproval: false,
        hasError: true,
        error: payload.error,
      };
    case SUBMIT_FS_QUESTIONNAIRE:
      return {
        ...state,
        submittingQuestionnaire: true,
      };
    case SUBMIT_FS_QUESTIONNAIRE_COMPLETED:
      const answers = payload.answers || {};
      return {
        ...state,
        submittingQuestionnaire: false,
        seal_stamp_clear: answers['7'],
        consignee_seal_match: answers['8'],
      };
    case SUBMIT_FS_QUESTIONNAIRE_FAILED:
      return {
        ...state,
        submittingQuestionnaire: false,
        hasError: true,
        error: payload.error,
      };
    case SET_DATE_RANGE:
      return {
        ...state,
        selectedDateRange: action.payload.dates,
        selectedDateStrings: action.payload.dateStrings,
      };
    case FETCH_OCR_DASHBOARD_DATA:
      return {
        ...state,
        isOcrDataFetching: true,
      };
    case FETCH_OCR_DASHBOARD_DATA_COMPLETED:
      if (extraParams.download) {
        return {
          ...state,
          isOcrDataFetching: false,
        };
      }
      return {
        ...state,
        isOcrDataFetching: false,
        ocrDashboardData: payload,
        ocrDashboardFilter: payload.filters,
        hasError: false,
      };
    case FETCH_OCR_DASHBOARD_DATA_FAILED:
      return {
        ...state,
        isOcrDataFetching: false,
        hasError: true,
        error: payload.error,
      };

    case SAVE_OCR_DASHBOARD_DATA:
      return {
        ...state,
        isOCRDashboardDataSaved: true,
      };
    case SAVE_OCR_DASHBOARD_DATA_COMPLETED:
      return {
        ...state,
        isOCRDashboardDataSaved: false,
        ocrDashboardData: payload,
      };
    case SAVE_OCR_DASHBOARD_DATA_FAILED:
      return {
        ...state,
        isOCRDashboardDataSaved: false,
        hasError: true,
        error: payload.error,
      };
    case RE_RUN_GEMINI_PROMPT:
      return {
        ...state,
        reRunPromptFetched: true,
      };
    case RE_RUN_GEMINI_PROMPT_COMPLETED: {
      const {document_id, prompt_history} = payload;
      return {
        ...state,
        reRunPromptFetched: false,
        ocrDashboardData: {
          ...state.ocrDashboardData,
          documents: {
            ...state.ocrDashboardData.documents,
            [document_id]: {
              ...state.ocrDashboardData.documents[document_id],
              basicInfo: {
                ...state.ocrDashboardData.documents[document_id].basicInfo,
                prompt_history,
              },
            },
          },
        },
      };
    }

    case RE_RUN_GEMINI_PROMPT_FAILED:
      return {
        ...state,
        reRunPromptFetched: false,
        hasError: true,
        error: payload.error,
      };

    case OCR_DASHBOARD_FILTER:
      return {
        ...state,
        ocrDashboardFilter: payload,
      };

    case ASSIGN_DAVT_TASK:
      return {
        ...state,
        isAssigningTask: true,
      };

    case ASSIGN_DAVT_TASK_COMPLETED: {
      const {requestData} = payload || {};
      const {task_id} = requestData || {};

      // 1️⃣ Remove task from tasks map
      const updatedTasks = {...state.tasksData.tasks};
      delete updatedTasks[task_id];

      // 2️⃣ Remove task_id from task_id_list
      const updatedTaskIdList = (state.tasksData.task_ids || []).filter(
        (id) => id !== task_id,
      );

      return {
        ...state,
        isAssigningTask: false,
        tasksData: {
          ...state.tasksData,
          tasks: updatedTasks,
          task_ids: updatedTaskIdList,
          tab_counts: {
            ...state.tasksData.tab_counts,
            overdue_count: Math.max(
              (state.tasksData.tab_counts?.overdue_count || 0) - 1,
              0,
            ),
          },
        },
      };
    }

    case ASSIGN_DAVT_TASK_FAILED:
      return {
        ...state,
        isAssigningTask: false,
      };

    default:
      return state;
  }
};
